
<div class="titles-wrapper">
    <div class="title-container">
        <p>Version Panos</p>
        <input class="custom-input mb-2" type="text" [(ngModel)]="panosversion">
    </div>
</div>